import {
  ADD_SURVEY_SUCCESS,
  GET_SURVEY_FEATURE_SUCCESS,
  RESET_SURVEY_FEATURE,
  GET_SURVEY_LIST_SUCCESS,
  DELETE_SURVEY_SUCCESS,
  UPDATE_SURVEY_STATUS_SUCCESS,
  UPDATE_SURVEY_ORDER_SUCCESS,
  UPDATE_SURVEY_SUCCESS,
  OPEN_DELETE_SURVEY_MODAL,
  HIDE_DELETE_SURVEY_MODAL,
  RESET_SURVEY_LIST,
  GET_SURVEY_REPLY_SUCCESS,
  RESET_SURVEY_REPLY,
  GET_SURVEY_FEATURE_RECIPIENTS_SUCCESS,
  RESET_SURVEY_FEATURE_RECIPIENTS,
  GET_SURVEY_FEATURE,
  GET_SURVEY_FEATURE_FAILED,
  GET_SURVEY_LIST,
  GET_SURVEY_LIST_FAILED,
} from "./actionTypes"

const INIT_STATE = {
  surveyFeature: null,
  surveyList: [],
  isDeleteSurveyModalOpen: false,
  surveyReply: null,
  surveyFeatureRecipients: null,
  surveyLoading: false,
  listLoading: false,
  destroyed: false,
  listDestroyed: false,
}

const Survey = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_SURVEY_SUCCESS:
      if (action.payload.menu_feature) {
        return {
          ...state,
          surveyFeature: action.payload,
        }
      } else {
        return state
      }
    case GET_SURVEY_FEATURE:
      return {
        ...state,
        surveyLoading: true,
        destroyed: false,
      }
    case GET_SURVEY_FEATURE_FAILED:
      return {
        ...state,
        surveyLoading: false,
      }
    case GET_SURVEY_FEATURE_SUCCESS:
      return {
        ...state,
        surveyFeature: action.payload,
        surveyLoading: false,
      }
    case RESET_SURVEY_FEATURE:
      return {
        ...state,
        surveyFeature: null,
        surveyLoading: false,
        destroyed: true,
      }
    case GET_SURVEY_LIST:
      return {
        ...state,
        listLoading: true,
        listDestroyed: false,
      }
    case GET_SURVEY_LIST_FAILED:
      return {
        ...state,
        listLoading: false,
      }
    case GET_SURVEY_LIST_SUCCESS:
      return {
        ...state,
        surveyList: action.payload,
        listLoading: false,
      }
    case DELETE_SURVEY_SUCCESS:
    case UPDATE_SURVEY_STATUS_SUCCESS:
    case UPDATE_SURVEY_ORDER_SUCCESS:
      return {
        ...state,
        surveyList: action.payload,
      }
    case UPDATE_SURVEY_SUCCESS:
      if (action.payload.length > 0) {
        return {
          ...state,
          surveyList: action.payload,
        }
      } else {
        return state
      }
    case OPEN_DELETE_SURVEY_MODAL:
      return {
        ...state,
        isDeleteSurveyModalOpen: true,
      }
    case HIDE_DELETE_SURVEY_MODAL:
      return {
        ...state,
        isDeleteSurveyModalOpen: false,
      }
    case RESET_SURVEY_LIST:
      return {
        ...state,
        surveyList: [],
        listLoading: false,
        listDestroyed: true,
      }
    case GET_SURVEY_REPLY_SUCCESS:
      return {
        ...state,
        surveyReply: action.payload,
      }
    case RESET_SURVEY_REPLY:
      return {
        ...state,
        surveyReply: null,
      }
    case GET_SURVEY_FEATURE_RECIPIENTS_SUCCESS:
      return {
        ...state,
        surveyFeatureRecipients: action.payload,
      }
    case RESET_SURVEY_FEATURE_RECIPIENTS:
      return {
        ...state,
        surveyFeatureRecipients: null,
      }
    default:
      return state
  }
}

export default Survey
